import { useOutletContext } from 'react-router-dom';
import InvoiceDisplayModeSelect from 'components/invoiceList/InvoiceDisplayModeSelect';
import InvoiceMonthList from 'components/invoiceList/InvoiceMonthList';
import InvoiceSelectionBar from 'components/invoiceList/InvoiceSelectionBar';

const InvoiceContent = () => {
  const {
    monthInvoices,
    onImportInvoices,
    onClearInvoiceFilters,
    invoiceDisplay,
    period,
    invoiceSelection,
    onRetryInvoices,
    isInvoiceImportRunning,
    invoiceImportBanner,
  } = useOutletContext();

  // One scroll for the whole tab, not one in the table: the import banner and
  // the display choice go up with the list, the head of the table sticks to
  // the top and its footer to the bottom (InvoiceMonthList). The display
  // choice stays above the list whatever it shows: empty, failed or loading.
  // The selection bar, outside the scroll, floats over the bottom.
  return (
    <div className="relative flex flex-col flex-1 min-h-0">
      <div className="flex-1 min-h-0 overflow-auto thin-scrollbar">
        <div className="min-h-full flex flex-col gap-3">
          {invoiceImportBanner}
          <div className="flex-shrink-0">
            <InvoiceDisplayModeSelect {...invoiceDisplay} />
          </div>
          <InvoiceMonthList
            {...monthInvoices}
            period={period}
            onImport={onImportInvoices}
            onClearFilters={onClearInvoiceFilters}
            selection={invoiceSelection}
          />
        </div>
      </div>
      <InvoiceSelectionBar
        period={period}
        numbers={invoiceSelection.numbers}
        errorNumbers={invoiceSelection.errorNumbers}
        statuses={invoiceSelection.statuses}
        onRetry={onRetryInvoices}
        isImportRunning={isInvoiceImportRunning}
      />
    </div>
  );
};

export default InvoiceContent;
